/*
||--------------------------------------------------------------------------
|| Component: SelectField.jsx
|| Author: Sayed Ahmed
|| Description: Reusable select dropdown component with validation support
|| Features include error handling, placeholder, and required field support
||--------------------------------------------------------------------------
*/

import React from "react";
import { useTranslation } from "react-i18next";

export default function SelectField({
  label,
  name,
  register,
  errors = {},
  required = false,
  options = [],
  placeholder = "",
  className = "",
  disabled = false,
  ...props
}) {
  const { t } = useTranslation();
  const error = errors[name];

  return (
    <div className={`form-group mb-3 ${className}`}>
      <label className="form-label">
        {t(label)}
        {required && <span className="text-danger"> *</span>}
      </label>
      
      <select
        className={`form-select ${error ? "is-invalid" : ""}`}
        {...register(name, {
          required: required ? t(`${label} is required`) : false,
        })}
        disabled={disabled}
        {...props}
      >
        {placeholder && (
          <option value="" disabled>
            {t(placeholder)}
          </option>
        )}
        {options.map((option, index) => (
          <option key={index} value={option.value}>
            {t(option.label)}
          </option>
        ))}
      </select>
      
      {error && (
        <div className="invalid-feedback d-block">
          {error.message}
        </div>
      )}
    </div>
  );
}
